import { createContext, useContext, useEffect, useState } from 'react';
import { useSuggestionSearchBarContext } from '../../context';

type CrawlRequestErrorContextType = {
  error: boolean;
  touched: boolean;
  setError: (val: boolean) => void;
  setTouched: (val: boolean) => void;
  hasError: boolean;
};

const CrawlRequestErrorContext = createContext<
  CrawlRequestErrorContextType | undefined
>(undefined);

export const useCrawlRequestErrorContext = () => {
  const context = useContext(CrawlRequestErrorContext);
  if (!context)
    throw new Error(
      'useCrawlRequestErrorContext must be used within a Provider'
    );
  return context;
};

export const CrawlRequestErrorProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [error, setError] = useState(false);
  const [touched, setTouched] = useState(false);

  const { popupOpen } = useSuggestionSearchBarContext();

  useEffect(() => {
    setError(popupOpen);
  }, [popupOpen]);

  const hasError = error && touched;

  return (
    <CrawlRequestErrorContext.Provider
      value={{ error, touched, setError, setTouched, hasError }}
    >
      {children}
    </CrawlRequestErrorContext.Provider>
  );
};
